<template>
  <div>
    <div v-show="visible_doc" class="docTable">
      <a-drawer
        :title="previewFileName"
        placement="left"
        width="80%"
        @close="onClose"
        :visible="isPreviewVisible"
      >
        <a-spin :spinning="spinningPreview">
          <canvas
            v-if="docPdf === true"
            id="the-canvas"
            style="direction: ltr; width: 100%"
          />
          <img v-else :src="`${docPdf}`" style="width: 100%" />
          <div style="display: flex; justify-content: space-between">
            <a-button
              :disabled="currentPage - 1 < 1 ? true : false"
              @click="
                currentPage--;
                preview(fileSave);
              "
            >
              <a-icon type="left" />
              {{ $t("Prev") }}
            </a-button>
            <span>{{ currentPage }} / {{ countPages }}</span>
            <a-button
              :disabled="currentPage + 1 > countPages ? true : false"
              @click="
                () => {
                  currentPage++;
                  preview(fileSave);
                }
              "
            >
              {{ $t("Next") }}
              <a-icon type="right" />
            </a-button>
          </div>
        </a-spin>
      </a-drawer>
      <div class="documentSearch">
        <div class="functionalRow">
          <a-upload
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            :multiple="true"
            style="margin-right: 15px"
          >
            <a-button
              :disabled="rightEdit == 0"
              type="primary"
              icon="upload"
              :loading="uploading"
              style="width: 100%; margin-left: 15xp"
              >{{ uploading ? $t("Uploading") : $t("Add new") }}</a-button
            >
          </a-upload>
          <a-row type="flex" class="search-wrapper">
            <a-col style="flex: 1; margin-right: 15px">
              <a-dropdown :trigger="['click']">
                <a-input-search
                  class="ant-dropdown-link"
                  v-model="searchlabel"
                  @search="handleSearch()"
                  :placeholder="$t('Search by name')"
                >
                  <template slot="suffix">
                    <a-tooltip :title="$t('Search by title, name, tag')">
                      <a-icon
                        type="info-circle"
                        style="color: rgba(0, 0, 0, 0.45); margin-right: 5px"
                      />
                    </a-tooltip>
                  </template>
                </a-input-search>

                <a-menu slot="overlay" style="background-color: #fafafa">
                  <a-form
                    :form="form"
                    id="my_form_search_styl"
                    layout="vertical"
                    style="padding: 0 50px"
                  >
                    <a-menu-item key="5">
                      <a-form-item :label="$t('File creation date')">
                        <a-range-picker
                          v-decorator="[
                            'CREATE_TIME',
                            {
                              rules: [{ type: 'array', required: false }],
                              initialValue: [],
                            },
                          ]"
                        />
                      </a-form-item>
                      <a-form-item hidden>
                        <a-range-picker
                          v-decorator="[
                            'title',
                            {
                              rules: [{ required: false }],
                              initialValue: '',
                            },
                          ]"
                        />
                      </a-form-item>
                    </a-menu-item>

                    <a-menu-item key="6">
                      <a-form-item
                        style="text-align: center"
                        :label-col="{ span: 0 }"
                        :wrapper-col="{ span: 24 }"
                      >
                        <a-button type="primary" @click="handleSearch()">{{
                          $t("Search")
                        }}</a-button>
                        <a-button
                          @click="handleReset()"
                          style="margin-left: 50px"
                          >{{ $t("Reset") }}</a-button
                        >
                      </a-form-item>
                    </a-menu-item>
                  </a-form>
                </a-menu>
              </a-dropdown>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="documentTable">
        <a-table
          :columns="tableColumns"
          :dataSource="fileList"
          :row-key="(record) => record.mainid"
          :pagination="{
            total: totalItems,
            current: currentPageTable,
            defaultPageSize: 10,
            pageSizeOptions: ['10', '30', '50', '100'],
            showSizeChanger: true,
          }"
          size="middle"
          :loading="loading"
          tableLayout="auto"
          :scroll="{ x: true }"
          bordered
          @change="onChangeTable"
          :locale="{
            emptyText: $t('no data'),
          }"
        >
          <template
            slot="name"
            slot-scope="text, record"
            style="text-align: left"
          >
            <a-button
              @click="goSteps(record)"
              type="link"
              style="text-align: left"
              >{{ text }}</a-button
            >
          </template>

          <template
            slot="status"
            style="display: flex; justify-content: center"
          />

          <template slot="time_change" slot-scope="text">{{
            text != undefined ? text : ""
          }}</template>
          <template slot="actions" slot-scope="text, record">
            <div style="display: flex; justify-content: center">
              <a-tooltip placement="top">
                <template slot="title">{{ $t("Preview") }}</template>
                <a-icon
                  @click="previewFile(record)"
                  type="search"
                  class="iconBtn iconBtnSearch"
                />
              </a-tooltip>

              <a-popconfirm
                :title="$t('Delete file?')"
                v-show="record.status != 'ZARCHIWIZOWANY'"
                :ok-text="$t('Tak')"
                :cancel-text="$t('Nie')"
                @confirm="onDeleteFile(record)"
              >
                <a-tooltip placement="top">
                  <template slot="title">{{ $t("Delete") }}</template>
                  <a-icon type="delete" class="iconBtn iconBtnDelete" />
                </a-tooltip>
              </a-popconfirm>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <steps
      v-if="!visible_doc"
      :element="document_record"
      :profile="profile"
      :form_info="InitInfo"
      :responsible="responsible"
      :disableFromResponsible="disableFromResponsible"
      :current="current"
      :specialization="specialization"
      :user_setup="user_setup"
      @onChangeTable="onChangeTable"
      @back="onback"
      @preview="onpreview"
      :key_words="key_words"
    />
  </div>
</template>
<script>
import steps from "@/components/steps.vue";
import moment from "moment";
import {
  Sort,
  //  getDocumentAllStage,
  getFileInfoFirstStage,
  uploadFile,
  getPoglad,
  deleteFile,
  saveTableSize,
  getDiskFile,
} from "@/requestFunc";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");

export default {
  components: {
    steps,
  },
  props: [
    "InitInfo",
    "key_words",
    "specialization",
    "responsible",
    "user_setup",
  ],
  data() {
    const tableColumns = [
      {
        title: this.$t("ID"),
        dataIndex: "ID",
        key: "ID",
        sorter: true,
        sortDirections: ["descend", "ascend"],
        align: "center",
      },
      {
        title: this.$t("File name"),
        key: "NAME",
        sorter: true,
        sortDirections: ["descend", "ascend"],
        dataIndex: "NAME",
        align: "center",
        scopedSlots: { customRender: "name" },
      },
      {
        title: this.$t("Create time"),
        key: "CREATE_TIME",
        sorter: true,
        dataIndex: "CREATE_TIME",
        align: "center",
        customRender: (text) => {
          return moment(text).format("YYYY-MM-DD h:mm:ss");
        },
      },
      {
        title: this.$t("Preview"),
        key: "preview",
        align: "center",
        dataIndex: "DOWNLOAD_URL",
        fixed: "right",
        width: 130,
        scopedSlots: { customRender: "actions" },
      },
    ];

    return {
      indeterminate: true,
      checkAllInModal: false,
      visibleModal: false,
      loading: false,
      countPages: 1,
      currentPage: 1,
      totalItems: 0,
      fileSave: "",
      contractor: "",
      contractorTitle: "",
      size: "small",
      isPreviewVisible: false,
      spinningPreview: true,
      searchlabel: "",
      previewFileName: "",
      addFileList: [],
      fileList: [],
      iconCheck: undefined,
      uploading: false,
      sortedInfo: { sort_column: undefined, sort_order: undefined },
      filterInfo: undefined,
      profile: [],
      part_max: 0,
      docPdf: null,
      visible_doc: true,
      document_record: null,
      current: 0,
      currentPageTable: 1,
      rightEdit: 0,
      disableFromResponsible: false,
      form: this.$form.createForm(this, { name: "search", status: [] }),
      tableSizes: ["10", "20", "50", "100"],
      currentTableSize: this.InitInfo.table_size,
      tableColumns,
      columns: tableColumns,
    };
  },
  methods: {
    moment,
    handleChangeContractor() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          this.contractor = info.company[0].id.split("_")[1];
          this.contractorTitle = info.company[0].title;
        }
      );
    },
    onChangeTable(page, filter, sorter) {
      var params;
      this.form.validateFields((err, values) => {
        values["CREATE_TIME"] =
          values.CREATE_TIME.length != 0
            ? [
                moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

        params = values;
      });

      this.loading = true;

      getDiskFile(page, params, sorter)
        .done((res) => {
          let result = JSON.parse(res);
          this.fileList = [...result.allData];
          this.totalItems = result.total;
          this.currentPageTable = page.current;

          this.$emit("updateTotalFile", result.total);
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.loading = false;
        });
    },
    showFilteredTable(fileList) {
      return fileList.filter((item) => {
        if (this.InitInfo.fields_table.indexOf(item.key) != -1) return item;
      });
    },
    onClose() {
      this.isPreviewVisible = false;
      this.fileSave = undefined;
    },
    onDeleteFile(file) {
      this.changeSpinning();
      deleteFile(file.mainid, file.ID)
        .done((res) => {
          if (res == "success") {
            // this.$emit("filterDocList", file.ID);
            this.onChangeTable({
              current: this.currentPageTable,
              pageSize: 10,
            });
            this.$message.success(this.$t("file_deletion_succeed"));
          } else if (res == "error") {
            this.$message.error(this.$t("file_deletion_error"));
          }
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    previewFile(file, page) {
      getPoglad(file.ID).done((x) => {
        let file = JSON.parse(x);
        this.currentPage = page || 1;
        this.fileSave = file;
        this.preview(file);
      });
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    getMimeFromUint8Array(uint8Array) {
      const header = Array.from(uint8Array.slice(0, 4))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
      switch (header) {
        case "25504446":
          return "application/pdf"; // %PDF
        case "89504e47":
          return "image/png"; // PNG
        case "ffd8ffe0": // fallthrough
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg"; // JPG
        default:
          return "unknown";
      }
    },
    preview(doc) {
      let pdfAsArray = this.Uint8ArrayFromBase64(doc.base64file);
      const mimeType = this.getMimeFromUint8Array(pdfAsArray);
      // console.log("firstTab 📂 Detected MIME type:", mimeType);

      // if (doc.NAME.indexOf(".jpg") != -1 || doc.NAME.indexOf(".png") != -1) {
      if (mimeType === "image/png" || mimeType === "image/jpeg") {
        // this.docPdf = doc.DOWNLOAD_URL;
        this.docPdf = `data:${mimeType};base64,${doc.base64file}`;
        this.spinningPreview = false;
      } else {
        this.docPdf = true;
        this.spinningPreview = true;
        // var url = doc.DOWNLOAD_URL;
        // var pdfjsLib = window["pdfjs-dist/build/pdf"];
        // pdfjsLib.GlobalWorkerOptions.workerSrc =
        //   "//mozilla.github.io/pdf.js/build/pdf.worker.js";
        // var loadingTask = pdfjsLib.getDocument(url);
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        var loadingTask = pdfjsLib.getDocument(pdfAsArray);

        loadingTask.promise.then(
          (pdf) => {
            try {
              this.countPages = pdf.numPages;
              if (1 <= this.currentPage && this.countPages >= this.currentPage)
                pdf.getPage(this.currentPage).then((page) => {
                  var scale = 2.0;
                  var viewport = page.getViewport({ scale: scale });
                  var canvas = document.getElementById("the-canvas");
                  var context = canvas.getContext("2d");
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;
                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                  };
                  var renderTask = page.render(renderContext);
                  renderTask.promise.then(() => {
                    // eslint-disable-next-line
                    $("#the-canvas").css("border", "1px solid");
                    this.spinningPreview = false;
                    // eslint-disable-next-line
                    BX24.fitWindow();
                  });
                });
            } catch {
              this.spinningPreview = false;
            }
          },
          (reason) => {
            this.spinningPreview = false;
            console.error(reason);
          }
        );
      }
      this.previewFileName = doc.NAME;
      this.isPreviewVisible = true;
    },
    beforeUpload(file) {
      // console.log('fdsfsd');
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "addfile");
      formData.append("folder", this.user_setup.folder);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      // console.log("dffs");
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          this.addFileList = [];
          this.uploading = false;
          if (res["result"] == "success") {
            this.fileList.unshift(res["file"]);
            this.$message.success(this.$t("Upload successful") + ".");
          } else {
            this.$message.error(this.$t("Upload failed") + ".");
            this.$message.error(
              this.$t("Select a storage location from Bitrix24.Drive folders") +
                "."
            );
          }
        })
        .fail((e) => {
          this.uploading = false;
          console.error(e);
          this.$message.error(this.$t("Upload failed") + ".");
        });
    },
    handleSearch() {
      if (this.searchlabel) {
        this.form.setFieldsValue({
          title: this.searchlabel,
        });
      }

      this.form.validateFields((err, values) => {
        if (
          // eslint-disable-next-line
          $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
          // eslint-disable-next-line
          $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
        ) {
          // eslint-disable-next-line
          $(".search-wrapper input").click();
        }

        values["CREATE_TIME"] =
          values.CREATE_TIME.length != 0
            ? [
                moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
              ]
            : undefined;

        this.changeSpinning();
        this.filterInfo = values;

        getDiskFile({ current: 1, pageSize: 10 }, values)
          .done((data) => {
            let result = JSON.parse(data);
            this.totalItems = result.total;
            this.currentPageTable = 1;
            this.fileList = result.allData;
            this.$message.success(this.$t("Filter ok"));
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning();
          });
      });
    },
    handleReset() {
      if (
        // eslint-disable-next-line
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        // eslint-disable-next-line
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        // eslint-disable-next-line
        $(".search-wrapper input").click();
      }
      this.changeSpinning();

      this.form.resetFields();
      this.filterInfo = undefined;
      this.sortedInfo = { sort_column: undefined, sort_order: undefined };
      this.iconCheck = undefined;
      this.contractor = "";
      this.contractorTitle = "";

      getDiskFile()
        .done((data) => {
          let result = JSON.parse(data);
          this.totalItems = result.total;
          this.fileList = result.allData;
          this.currentPageTable = 1;
          this.$message.success("Reset filter ok");
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error loading files"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    handleChange(pagination, filters, sorter) {
      if (
        this.sortedInfo.sort_column != sorter["columnKey"] ||
        this.sortedInfo.sort_order != sorter["order"]
      ) {
        this.changeSpinning();

        if (Object.keys(sorter).length != 0) {
          this.sortedInfo = {
            sort_column: sorter["columnKey"],
            sort_order: sorter["order"],
          };
        } else {
          this.sortedInfo = { sort_column: undefined, sort_order: undefined };
        }

        Sort(0, this.sortedInfo, this.filterInfo)
          .done((data) => {
            let elem = JSON.parse(data);
            this.$emit("updateFiles", { files: elem });
            /*if (this.sortedInfo.sort_column != undefined) {
              this.$message.success(
                "Sort " +
                  this.sortedInfo.sort_order +
                  " from " +
                  this.sortedInfo.sort_column +
                  ", ok"
              );
            } else {
              this.$message.success("Sort reset ok");
            }*/
          })
          .fail((e) => {
            console.error(e);
            //this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning();
          });
      }
    },
    handleChangeTableSize(value) {
      var table_size_value = value;
      this.changeSpinning();
      saveTableSize(table_size_value)
        .done(() => {
          this.InitInfo.table_size = table_size_value;
          this.$message.success(this.$t("Table size have been saved!"));
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error"));
        })
        .always(() => {
          this.changeSpinning();
        });
    },
    onback() {
      this.$emit("refresh");
      //this.visible_doc = data.visible_doc;
      this.visible_doc = !this.visible_doc;
      this.$emit("changeVisibleTabs", false);
      this.onChangeTable({ current: this.currentPageTable, pageSize: 10 });
    },
    onpreview(data) {
      this.previewFile(data.file, data.page);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    goSteps(record) {
      this.changeSpinning();

      if (record.status == undefined || record.status == "NOWY") {
        this.current = 0;
      } else if (record.status == "DO OPISANIA") {
        this.current = 1;
      } else {
        this.current = 2;
      }

      this.disableFromResponsible = false;
      //let first_stage = this.current == 0 ? true : false;
      let id_file = record.ID;
      getFileInfoFirstStage(true, id_file)
        .done((data) => {
          this.$message.info(this.$t("Download complete!"));
          let item = data == "" ? {} : JSON.parse(data);
          Object.assign(record, item);
        })
        .fail((e) => {
          console.error(e);
          this.$message.error(this.$t("Error loading document"));
        })
        .always(() => {
          // eslint-disable-next-line
          BX24.callMethod("profile", {}, (res) => {
            this.profile = res.data();
            this.visible_doc = !this.visible_doc;
            this.$emit("changeVisibleTabs", true);
            this.document_record = record;
            if (record.crm_user == undefined || record.crm_user == true) {
              this.disableFromResponsible = false;
            } else if (
              record.crm_user == false &&
              this.responsible.indexOf(res.answer.result.ID + "") != -1 &&
              this.current != 0 &&
              res.answer.result.ADMIN != true
            ) {
              this.current = 0;
              this.disableFromResponsible = true;
            }
            this.changeSpinning();
            // eslint-disable-next-line
            BX24.fitWindow();
          });
        });
    },
    resize() {
      // eslint-disable-next-line
      BX24.resizeWindow(
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "width"
          )
        ),
        parseInt(
          // eslint-disable-next-line
          $("body>div>.ant-spin-nested-loading>.ant-spin-container").css(
            "height"
          )
        )
      );
    },
  },
  mounted() {
    this.onChangeTable({ current: 1, pageSize: 10 });
    // this.totalItems = this.InitInfo.total;
    // this.columns = this.tableColumns.filter(item => {
    //   if (this.InitInfo.fields_table.indexOf(item.key) != -1) return item;
    // });
    // eslint-disable-next-line
    BX24.init(() => {
      // eslint-disable-next-line
      let isAdm = BX24.isAdmin();
      // eslint-disable-next-line
      BX24.callMethod("user.current", {}, (res) => {
        this.rightEdit =
          isAdm || this.user_setup.responsible.includes(res.data().ID) ? 1 : 0;
      });
    });
    // eslint-disable-next-line
    BX24.fitWindow();
  },
  updated() {
    this.resize();
  },
};
</script>
<style scoped>
.docTable {
  display: flex;
  flex-direction: column;
}
.documentSearch {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 15px;
}
.documentSearch > div {
  margin: 5px 0px;
  width: 100%;
  text-align: left;
  align-self: flex-start;
}
.documentSearch .functionalRow {
  display: flex;
  justify-content: space-around;
  /* justify-content: space-between; */
  margin-bottom: 5px;
}
.documentSearch .functionalRow .documentAdd__btn {
  margin-right: 15px;
  display: flex;
  align-self: center;
}
.documentSearch .functionalRow .search-wrapper {
  width: 100%;
}
.documentTable {
  min-height: 401px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-dropdown-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.table-operations {
  margin-bottom: 16px;
}

.table-operations > div {
  margin-right: 10px;
}

.iconBtn {
  font-size: 20px;
}
.iconBtnSettings {
  font-size: 32px;
}

.iconBtnSettings:hover,
.iconBtnSearch:hover {
  color: #1890ff;
}

.iconBtnDelete:hover {
  color: #f5222d;
}

.ant-pagination {
  background-color: red;
}

.ant-table {
  /* white-space: nowrap; */
  border-collapse: collapse;
  /* border-spacing:0px; */
}
</style>
